import {
  Alert,
  Box,
  Button,
  Card,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  IconButton,
  MenuItem,
  Paper,
  Radio,
  RadioGroup,
  Select,
  TextField,
  Tooltip,
  Typography,
  useTheme,
} from "@mui/material";
import React, { useEffect, useState, useRef } from "react";
import { Fields } from "../Fields";
import ModalBox from "../../../ui/ModalBox";
import { useNavigate } from "react-router-dom";
import { useMember } from "../provider";
import ErrorsList from "../../../ui/ErrorsList";
import MonetizationOnOutlinedIcon from "@mui/icons-material/MonetizationOnOutlined";
import { QRCodeSVG } from "qrcode.react";
import { toPng } from "html-to-image";
import jsPDF from "jspdf";
import {
  CalDate,
  renderTextWithLinks,
  printWrappedTextWithLinks,
} from "../../../utilities/functions";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import "dayjs/locale/de";
import "dayjs/locale/en-gb";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

const BoxInfo = ({ member, reload, setReload }) => {
  let theme = useTheme();
  let navigate = useNavigate();

  const [open, setOpen] = useState(false);
  const [error, setError] = useState();
  const [openCharge, setOpenCharge] = useState(false);
  const [qrSize, setQrSize] = useState(window.innerWidth < 768 ? 40 : 150);
  const svgRef = useRef();
  const pdfRef = useRef();
  const [locale] = useState("en-gb");
  const [selectedSite, setSelectedSite] = useState(() => {
    try {
      return member?.printingInfo ? JSON.parse(member.printingInfo).selectedSite || "" : "";
    } catch {
      return "";
    }
  });
  const [relatedCompany] = useState(
    member?.relatedCompany || "",
  );

  const [selectedPlate, setSelectedPlate] = useState(() => {
    try {
      return member?.printingInfo ? JSON.parse(member.printingInfo).selectedPlate || "" : "";
    } catch {
      return "";
    }
  });
  const [mobileNumber, setMobileNumber] = useState(member?.mobile || "");
  const [expireDate, setExpireDate] = useState(member?.expireDate || "");

  const {
    state: { memberQRField },
    dispatch,
    edit,
    remove,
  } = useMember();
const toggleField = (field) => {
  dispatch({
    type: "set_memberQRFields",
    payload: { ...memberQRField, [field]: !memberQRField[field] },
  });
};

  const getQrColors = () => {
    if (memberQRField.BlackonWhite === "white-on-black") {
      return { bgColor: "#000000", fgColor: "#ffffff" };
    }
    return { bgColor: "#ffffff", fgColor: "#000000" };
  };

  const getPlanName = (id) => {
    const planMap = {
      1: "Company",
      2: "Site",
      3: "Recharge",
    };
    return planMap[id] || "";
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSavePrintingInfo = async () => {
    try {
      const qrData = {
        site: memberQRField.site,
        plate: memberQRField.plate,
        mobile: memberQRField.mobile,
        expireDate: memberQRField.expireDate,
        relatedCompany: memberQRField.relatedCompany,
        text: memberQRField.text,
        checkedText: memberQRField.checkedText,
        BlackonWhite: memberQRField.BlackonWhite,
        selectedSite: memberQRField.site ? selectedSite : null,
        selectedPlate: memberQRField.plate ? selectedPlate : null,
      };
      await edit(
        {
          planId: member?.planId,
          mobile: member?.mobile,
          memberName: member?.memberName,
          startDate: member?.startDate,
          expireDate: member?.expireDate,
          siteIds: member?.sites?.map((s) => s.id) || [],
          serviceIds:
            member?.services?.flatMap(
              (s) => s?.servises?.map((x) => x.id) || [],
            ) || [],
          timesPerDay: member?.timesPerDay,
          relatedCompany: member?.relatedCompany,
          amount: member?.amount ?? 0,
          paymentTypeId: member?.paymentTypeId ?? 0,
          isActive: member?.isActive ?? true,
          printingInfo: JSON.stringify(qrData),
        },
        member?.id,
      );
    } catch (e) {
      console.error("Save printingInfo failed:", e);
    }
  };
  useEffect(() => {
    if (member?.printingInfo) {
      try {
        const parsed = JSON.parse(member.printingInfo);
        if (parsed.selectedSite) setSelectedSite(parsed.selectedSite);
        if (parsed.selectedPlate) setSelectedPlate(parsed.selectedPlate);
      } catch (e) {}
    }
  }, [member]);

  const handleDelete = () => {
    try {
      remove(member?.id);
      navigate(-1);
    } catch (e) {
      console.error("Delete error:", e);
      window.scroll(0, 0);
      setError({
        title: e?.response?.data?.message || "Something went wrong",
      });
    }
  };

  useEffect(() => {
    const handleResize = () => {
      setQrSize(window.innerWidth < 768 ? 180 : 300);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleExportSVG = () => {
    const svgElement = svgRef.current;
    if (!svgElement) return;

    const serializer = new XMLSerializer();
    let source = serializer.serializeToString(svgElement);
    source = '<?xml version="1.0" standalone="no"?>\r\n' + source;

    const blob = new Blob([source], { type: "image/svg+xml;charset=utf-8" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `qrcode_${member?.id}.svg`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

 const handleExportPDF = async () => {
   const svgElement = pdfRef.current;
   if (!svgElement) return;
   try {
     const dataUrl = await toPng(svgElement, {
       backgroundColor: getQrColors().bgColor,
       pixelRatio: 2,
     });
     const pdf = new jsPDF({
       orientation: "portrait",
       unit: "mm",
       format: "a4",
     });

     const pageWidth = pdf.internal.pageSize.getWidth();
     const marginX = 20;
     const contentWidth = pageWidth - marginX * 2;
     const imgWidth = 80;
     const imgHeight = 80;
     const x = (pageWidth - imgWidth) / 2;
     let y = 30;

     pdf.setFontSize(16);
     pdf.setTextColor(0, 0, 0);
     pdf.text("Member QR Code", pageWidth / 2, y, { align: "center" });
     y += 15;

     pdf.addImage(dataUrl, "PNG", x, y, imgWidth, imgHeight);
     y += imgHeight + 10;

     pdf.setFontSize(10);
     pdf.setTextColor(80, 80, 80);

     if (selectedSite && memberQRField.site) {
       pdf.text(`Site: ${selectedSite}`, marginX, y);
       y += 6;
     }
     if (relatedCompany && memberQRField?.relatedCompany) {
       pdf.text(`Related Company: ${relatedCompany}`, marginX, y);
       y += 6;
     }
     if (selectedPlate && memberQRField.plate) {
       pdf.text(`Plate: ${selectedPlate}`, marginX, y);
       y += 6;
     }
     if (mobileNumber && memberQRField.mobile) {
       pdf.text(`Mobile: ${mobileNumber}`, marginX, y);
       y += 6;
     }
     if (expireDate && memberQRField.expireDate) {
       pdf.text(`Expire Date: ${expireDate}`, marginX, y);
       y += 6;
     }

     if (memberQRField.text) {
       pdf.setTextColor(0, 0, 0);
       pdf.setFont(undefined, "bold");
       pdf.text("Additional Details:", marginX, y);
       pdf.setFont(undefined, "normal");
       y += 6;

       pdf.setTextColor(80, 80, 80);
       y = printWrappedTextWithLinks(
         pdf,
         memberQRField.text,
         marginX,
         y,
         contentWidth,
         6,
       );
     }

     pdf.save(`qrcode_${member?.id}.pdf`);
   } catch (error) {
     console.error("PDF generation failed:", error);
   }
 };


  return (
    <>
      <Paper
        elevation={0}
        sx={{
          p: theme.dimensions.padding,
          mt: theme.dimensions.mt,
          mb: theme.dimensions.mb,
          background: theme.color.PaperbgColor,
          width: "95%",
        }}
      >
        {error && (
          <Alert severity="error" sx={{ my: 3 }}>
            <ErrorsList error={error} />
          </Alert>
        )}

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 4,
          }}
        >
          <Typography variant="Poster" component="h4" gutterBottom>
            Member Information
          </Typography>
          <Button
            variant="contained"
            sx={{
              background: "#FF4747",
              "&:hover": { background: "#d32f2f" },
            }}
            onClick={() => setOpen(true)}
          >
            Delete
          </Button>
        </Box>
        <Grid container spacing={4}>
          <Grid item xs={12} md={5}>
            <Grid container spacing={2}>
              {Fields.map((f, index) => (
                <Grid item xs={12} sm={6} key={index} sx={{ height: "50px" }}>
                  {f.name === "tagId" && !member?.tagId ? null : (
                    <Box sx={{ mb: 1.5 }}>
                      <span style={{ color: theme.color.PaperlabelColor }}>
                        {f.label}:{" "}
                      </span>
                      <span>
                        {f.label === "Company"
                          ? member?.company?.companyName || "—"
                          : f.name === "planId"
                            ? getPlanName(member?.planId) || "—"
                            : f.name === "tagId"
                              ? (member?.tagId ?? "—")
                              : (member?.[f.name] ?? "—")}
                      </span>
                    </Box>
                  )}
                </Grid>
              ))}
            </Grid>
          </Grid>
          <Grid item xs={12} md={7}>
            <Card sx={{ p: 2 }}>
              <FormControl component="fieldset" sx={{ mt: 1 }}>
                <FormLabel
                  component="legend"
                  sx={{ fontSize: "12px", color: "#555" }}
                >
                  QR Color Scheme
                </FormLabel>
                <RadioGroup
                  row
                  value={memberQRField.BlackonWhite}
                  onChange={(e) => {
                    dispatch({
                      type: "set_memberQRFields",
                      payload: {
                        ...memberQRField,
                        BlackonWhite: e.target.value,
                      },
                    });
                  }}
                >
                  <FormControlLabel
                    value="black-on-white"
                    control={<Radio />}
                    label="Black on White"
                  />
                  <FormControlLabel
                    value="white-on-black"
                    control={<Radio />}
                    label="White on Black"
                  />
                </RadioGroup>
              </FormControl>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column", sm: "row" },
                  gap: 4,
                  mt: 2,
                }}
              >
                <Box
                  sx={{
                    flex: "0 0 200px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <Box ref={svgRef} sx={{ textAlign: "center" }}>
                    <QRCodeSVG
                      value={`${member?.id},${member?.mobile},${member?.planId}`}
                      size={qrSize}
                      bgColor={getQrColors().bgColor}
                      fgColor={getQrColors().fgColor}
                      level="M"
                      className="qr-code-svg"
                      ref={pdfRef}
                    />

                    <Box sx={{ mt: 2, textAlign: "left", width: "100%" }}>
                      {selectedSite && memberQRField.site && (
                        <Typography
                          variant="caption"
                          display="block"
                          sx={{ color: "#666" }}
                        >
                          Site: {selectedSite}
                        </Typography>
                      )}
                      {relatedCompany && memberQRField?.relatedCompany && (
                        <Typography
                          variant="caption"
                          display="block"
                          sx={{ color: "#666" }}
                        >
                          Related Company: {relatedCompany}
                        </Typography>
                      )}
                      {selectedPlate && memberQRField.plate && (
                        <Typography
                          variant="caption"
                          display="block"
                          sx={{ color: "#666" }}
                        >
                          Plate: {selectedPlate}
                        </Typography>
                      )}
                      {mobileNumber && memberQRField?.mobile && (
                        <Typography
                          variant="caption"
                          display="block"
                          sx={{ color: "#666" }}
                        >
                          Mobile: {mobileNumber}
                        </Typography>
                      )}
                      {expireDate && memberQRField?.expireDate && (
                        <Typography
                          variant="caption"
                          display="block"
                          sx={{ color: "#666" }}
                        >
                          Expire Date: {expireDate}
                        </Typography>
                      )}
                      {memberQRField?.text &&memberQRField?.checkedText&& (
                        <Typography
                          variant="caption"
                          display="block"
                          sx={{
                            color: "#666",
                            whiteSpace: "pre-wrap",
                          }}
                        >
                          <strong>Additional Details:</strong>{" "}
                          {renderTextWithLinks(memberQRField?.text)}
                        </Typography>
                      )}
                    </Box>
                  </Box>
                  <Box
                    sx={{
                      mt: 2,
                      display: "flex",
                      flexDirection: "column",
                      width: "100%",
                      gap: 1,
                    }}
                  >
                    <Tooltip title="Export as PDF" arrow>
                      <IconButton
                        onClick={handleExportPDF}
                        sx={{
                          border: "1px solid",
                          borderColor: "divider",
                          borderRadius: 2,
                          width: "100%",
                          p: 1.5,
                          fontSize: "14px",
                          justifyContent: "center",
                        }}
                      >
                        Export as PDF
                      </IconButton>
                    </Tooltip>

                    <Tooltip title="Export as SVG" arrow>
                      <IconButton
                        onClick={handleExportSVG}
                        sx={{
                          border: "1px solid",
                          borderColor: "divider",
                          borderRadius: 2,
                          width: "100%",
                          p: 1.5,
                          fontSize: "14px",
                          justifyContent: "center",
                        }}
                      >
                        Export as SVG
                      </IconButton>
                    </Tooltip>
                  </Box>
                </Box>
                <Box
                  sx={{
                    flex: 1,
                    display: "flex",
                    flexDirection: "column",
                    gap: 2,
                  }}
                >
                  <FormControlLabel
                    control={<Checkbox checked={true} disabled />}
                    label="QR (Always Enabled)"
                  />
                  <Box>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={memberQRField.site}
                          onChange={() => toggleField("site")}
                        />
                      }
                      label="Site"
                    />
                    <FormControl fullWidth sx={{ mt: 1 }}>
                      <Select
                        disabled={!memberQRField.site}
                        value={selectedSite}
                        inputProps={{ "aria-label": "Site select" }}
                        sx={{ fontSize: "12px", height: "40px" }}
                        onChange={(e) => setSelectedSite(e.target.value)}
                      >
                        {member?.sites?.map((item) => (
                          <MenuItem key={item.id} value={item.siteName}>
                            {item.siteName}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Box>
                  <Box>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={memberQRField.relatedCompany}
                          onChange={() => toggleField("relatedCompany")}
                        />
                      }
                      label="Related Company"
                    />
                    <FormControl fullWidth sx={{ mt: 1 }}>
                      <TextField
                        required
                        type="text"
                        size="small"
                        fullWidth
                        disabled={true}
                        sx={{ mt: 1 }}
                        placeholder="Enter related company"
                        value={relatedCompany}
                      />
                    </FormControl>
                  </Box>
                  <Box>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={memberQRField.plate}
                          onChange={() => toggleField("plate")}
                        />
                      }
                      label="Plate"
                    />
                    <FormControl fullWidth sx={{ mt: 1 }}>
                      <Select
                        disabled={!memberQRField?.plate}
                        value={selectedPlate}
                        inputProps={{ "aria-label": "Plate select" }}
                        sx={{ fontSize: "12px", height: "40px" }}
                        onChange={(e) => setSelectedPlate(e.target.value)}
                        
                      >
                        {member?.cars?.map((item) => (
                          <MenuItem key={item.id} value={item.plate}>
                            {item.plate}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Box>
                  <Box>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={memberQRField.mobile}
                          onChange={() => toggleField("mobile")}
                        />
                      }
                      label="Mobile"
                    />
                    <TextField
                      required
                      disabled={true}
                      type="text"
                      size="small"
                      fullWidth
                      sx={{ mt: 1 }}
                      placeholder="Enter mobile number"
                      value={mobileNumber}
                      onChange={(e) => setMobileNumber(e.target.value)}
                    />
                  </Box>

                  <Box>
                    <Box>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={memberQRField?.expireDate}
                            onChange={() => toggleField("expireDate")}
                          />
                        }
                        label="Expire Date"
                      />
                    </Box>
                    <LocalizationProvider
                      key={"ExpireDate"}
                      dateAdapter={AdapterDayjs}
                      adapterLocale={locale}
                    >
                      <DatePicker
                        type="text"
                        size="small"
                        disabled={true}
                        sx={{ mt: 1, width: "full" }}
                        defaultValue={member && dayjs(member?.expireDate)}
                        onChange={(date) => {
                          setExpireDate(CalDate(date));
                        }}
                      />
                    </LocalizationProvider>
                  </Box>
                  <Box>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={memberQRField?.checkedText}
                          onChange={() => toggleField("checkedText")}
                        />
                      }
                      label="Additional Details"
                    />
                    <TextField
                      multiline
                      rows={4}
                      type="text"
                      fullWidth
                      size="small"
                      sx={{ mt: 1 }}
                      placeholder="Enter additional details..."
                      disabled={!memberQRField?.checkedText}
                      value={memberQRField?.text}
                      onChange={(e) => {
                        dispatch({
                          type: "set_memberQRFields",
                          payload: {
                            ...memberQRField,
                            text: e.target.value,
                          },
                        });
                      }}
                    />
                  </Box>
                </Box>
              </Box>
            </Card>
          </Grid>
        </Grid>

        {/* Action Buttons */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            gap: 2,
            mt: 4,
          }}
        >
          {member?.planId === 3 && (
            <Button
              onClick={() => setOpenCharge(!openCharge)}
              sx={{
                background: "white",
                color: theme.color.blackBackground,
                border: `1px solid ${theme.color.blackBackground}`,
                "&:hover": { background: "#f5f5f5" },
                textTransform: "capitalize",
                px: 3,
              }}
              startIcon={<MonetizationOnOutlinedIcon />}
            >
              Charge
            </Button>
          )}
          <Button
            onClick={handleSavePrintingInfo}
            sx={{
              background: "white",
              color: theme.color.blackBackground,
              border: `1px solid ${theme.color.blackBackground}`,
              "&:hover": { background: "#f5f5f5" },
              px: 4,
            }}
          >
            Save QR
          </Button>
          <Button
            onClick={() => navigate("/members/edit/" + member?.id)}
            sx={{
              background: theme.color.blackBackground,
              color: "white",
              "&:hover": { background: theme.color.black },
              px: 4,
            }}
          >
            Edit
          </Button>
        </Box>

        {/* Delete Modal */}
        <ModalBox
          open={open}
          operation="delete"
          handleClose={handleClose}
          handleOperation={() => {
            handleDelete();
            setOpen(false);
          }}
          text="Do you want to complete the process of deleting all information?"
        />
      </Paper>

      {/* Charge Modal */}
      <ModalBox
        open={openCharge}
        operation="chargeMember"
        handleClose={() => {
          setOpenCharge(!openCharge);
          setReload(!reload);
        }}
        row={member}
        text="Charge operation successfully"
      />
    </>
  );
};

export default React.memo(BoxInfo);
